  function openTabs(evt, divName, bannerName, elem) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].classList.remove("active");
    }
    document.getElementById(divName).style.display = "block";
    document.getElementById(bannerName).style.display = "block";
    if (evt.currentTarget) {
      evt.currentTarget.classList.add("active");
    }
  
    if (bannerName == 'banner1') {
      document.querySelector('.banner-tabs').classList.add('with-img');
      document.querySelector('.banner-tabs .img-banner-1-mobile').classList.remove('hideimg');
    } else {
      document.querySelector('.banner-tabs').classList.remove('with-img');
      document.querySelector('.banner-tabs .img-banner-1-mobile').classList.add('hideimg');
    }
    var catFilter = elem.getAttribute('data-filter');
    var items = document.querySelectorAll('.review-all-items .items');
    items.forEach(function (item) {
      item.classList.remove('hide-item');
    });
  
    if (catFilter !== 'All') {
      items.forEach(function (item) {
        if (!item.getAttribute('data-tab').includes(catFilter)) {
          item.classList.add('hide-item');
        }
      });
    }

  // Mobile View Filter //
    var mobileTabsNavi = document.querySelector('.mobile-tabs-navi');
    var selecter = mobileTabsNavi.querySelector('.selecter');
    var list = mobileTabsNavi.querySelector('.list');
    var customOptionElements = list.querySelectorAll('.custom-option');
    var reviewAllItems = document.querySelectorAll('.review-all-items .items'); 
    let clickCounter = 0;
    selecter.addEventListener('click', function() {
      if (true) {
        list.classList.add('open');
        clickCounter++;
        if (clickCounter >= 3) {
          list.classList.remove('open');
          clickCounter = 0;
        }
      }
    });

mobileTabsNavi.addEventListener('click', function(event) {
  var target = event.target;
  if (target.classList.contains('custom-option')) {
    var txt = target.innerHTML;
    list.classList.remove('open');
    selecter.innerHTML = txt;
    var catFilter = target.getAttribute('data-val');
    reviewAllItems.forEach(function(item) {
      item.classList.remove('hide-item');
      var dataTab = item.getAttribute('data-tab');
      if (catFilter !== 'All' && !dataTab.includes(catFilter)) {
        item.classList.add('opne');
      }
    });
    var tabButton = document.querySelector('.tab button[data-filter="' + catFilter + '"]');
    if (tabButton) {
      tabButton.click();
    }
  }
});
}
  var defaultOpenElement = document.getElementById("defaultOpen");
  if (defaultOpenElement) {
    defaultOpenElement.click();
  }


// Snippets Model Js //

    function openReviewModal(evt) {
      var content = evt.closest('.content');
      var txtFull = content.querySelector('.txt-full').innerHTML;
      var name = content.querySelector('h3').innerHTML;
      var img = content.parentElement.querySelector('img').getAttribute('src');
      var pimg = content.querySelector('.prod').getAttribute('data-p-img');
      var targetUrl = content.querySelector('.prod a').getAttribute('href');
      txtFull += '<h3>' + name + '</h3>';
      document.querySelector('.review-overlay .txt-content').innerHTML = txtFull;
      document.querySelector('.review-overlay').classList.remove('review-overlay-hidden');
      document.querySelector('.review-overlay .img-content img').src = img;
      document.querySelector('.review-overlay .prd-content img').src = pimg;
      document.querySelector('.review-overlay .prd-content a').href = targetUrl;
    
      content.querySelector('.txt').classList.toggle('hiddentxt');
      content.querySelector('.txt-full').classList.toggle('hiddentxt');
      content.querySelector('.open-modal').classList.toggle('less');
      content.querySelector('.mobile-product-box').classList.toggle('toggleHide');
    }
    
    function closeReviewModal() {
      document.querySelector('.review-overlay').classList.add('review-overlay-hidden');
}
